<template>
  <div>
    <div class="card">
      <div class="bg-blue-light p-1">
        <TitleButton
            btnTitle="Register"
            :showBtn="false"
            :showAddNew="true"
            title="Contacts List"
            @onClickAddNewButton="onClickAddNewButton"
        />
      </div>

      <div class="my-2 px-2">
        <DateQuerySetter
            btnTitle="Go"
            @onClickGo="getContactsList"
        >
          <div class="col-12 col-sm-6 col-md-5 col-lg-4">
            <label for="colFormLabel" class="col-form-label">Roles</label>
            <v-select
                placeholder="Select Roles"
                v-model="roleId"
                :options="companyRules"
                label="name"
                :reduce="name => name.id"
            />
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mt-1">
            <div class="d-flex align-items-center justify-content-between filter-label">
              <label for="colFormLabel" class="col-form-label">Contact Owner: </label>
              <span class="filter-search-icon cursor-pointer" @click="onOpenContactOwnerSearchModal">
                <i class="fas fa-search"></i>
              </span>
            </div>
            <AsyncSelect
                placeholder="Select Contact Owner"
                v-model="contactOwner"
                :api-service="fetchContactProfiles"
                :additional-query="{ roles: 'employee' }"
                :format-label="formatPatientLabel"
            />
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mt-1">
            <div class="d-flex align-items-center justify-content-between filter-label">
              <label for="colFormLabel" class="col-form-label">Shareholder: </label>
              <span class="filter-search-icon cursor-pointer" @click="onOpenShareholderSearchModal">
                <i class="fas fa-search"></i>
              </span>
            </div>
            <AsyncSelect
                placeholder="Select Shareholder"
                v-model="shareholderContact"
                :api-service="fetchContactProfiles"
                :additional-query="{ roles: 'shareholder' }"
                :format-label="formatPatientLabel"
            />
          </div>
          <template #bottom>
            <div class="col-2 col-12 col-sm-2 col-md-2 col-lg-2 mt-3">
              <button
                  style="min-width: 64px;"
                  @click="exportList"
                  class="btn btn-primary btn-block waves-effect waves-float waves-light"
              >Export
              </button>
            </div>
          </template>
        </DateQuerySetter>
      </div>

      <div class="col-12 px-2 my-2">
        <div class="card card-height">
          <div class="table-responsive">
            <table class="table">
              <thead>
              <tr>
                <th>Photo</th>
                <th>Full Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Contact Owner</th>
                <th>Bank-Branch name</th>
                <th>Bank-Branch Location</th>
                <th>Location</th>
                <th>Full Address</th>
                <th>Category</th>
                <th>Contact Roles</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, i) in contacts" :key="i">
                <td><img :src="item.photo" alt="Generic placeholder image" class="w-44"/></td>
                <td>{{ item.full_name }}</td>
                <td>{{ item.phone }} <span v-if="item.mobile_no">{{ item.mobile_no}}</span></td>
                <td>{{ item.email }}</td>
                <td>{{ item.contact_owner_name }} <span v-if="item.contact_owner_serial_no">({{ item.contact_owner_serial_no }})</span></td>
                <td>{{ item.dealer && item.dealer.contact_profile.name }}</td>
                <td>{{ item.dealer && item.dealer.area.name }}</td>
                <td>{{ item.location }}</td>
                <td>{{ item.full_address }}</td>
                <td class="capitalize">{{ item.contact_type }}</td>
                <td> {{ item.roles }}</td>
              </tr>
              </tbody>
            </table>
            <p v-if="!contacts.length" class="text-center mt-5">No data</p>
          </div>
        </div>
      </div>

      <div class="px-2 position-absolute bottom-0">
        <Pagination
            :offset="offset"
            @onPageChange="onPageChange"
            ref="pagination"
        />
      </div>
    </div>
    <ShareHolderDropdownFilter
        v-if="$store.state.isModalOpenThree"
        :companyRoles="companyRoles"
        @onSearchContact="onSearchContact"
        @onSearchByOwner="onSearchByOwner"
    />
    <Loader v-if="loading"/>
  </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton.vue';
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import {useRoute, useRouter} from "vue-router";
import {computed, inject, onMounted, ref} from "vue";
import Loader from "@/components/atom/LoaderComponent.vue";
import Pagination from "@/components/atom/Pagination.vue";
import {useStore} from "vuex";
import handleRole from "@/services/modules/role";
import handleCompanyContact from "@/services/modules/companyContact";
import ShareHolderDropdownFilter from "@/components/molecule/procurement/shareholder-register/ShareHolderDropdownFilter.vue";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleContact from "@/services/modules/contact";
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";

const $route = useRoute();
const $router = useRouter();
const $store = useStore();

const showError = inject('showError');
const showSuccess = inject('showSuccess');
const {fetchCompanyContacts} = handleCompanyContact();
const {fetchCompanyDefaultRoles} = handleRole();
const {fetchContactProfiles} = handleContact();
const {formatPatientLabel} = useAsyncDropdownHelper();
const offset = ref(10);
const loading = ref(false);
const contacts = ref([])
const companyRules = ref([])
const roleId = ref(null)
const searchTerm = ref('');
const companyRoles = ref([]);
const companyRolesFetched = ref(false);
const contactOwner = ref(null);
const shareholderContact = ref(null);
// computed
const start = computed(() => $route.query.start);
const end = computed(() => $route.query.end);
const page = computed(() => $route.query.page);
const companyId = computed(() => $route.params.companyId);
const token = localStorage.getItem('token');

//methods
const setPaginationData = (data) => {
  $store.commit('setPaginationData', data)
};
const resetPagination = () => {
  $store.commit('resetPagination')
};

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, $route.query)
  routeQuery.page = page
  await $router.push({path: $route.path, query: routeQuery})
  await getContactsList()
}
const setPagination = (data) => {
  setPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const onClickAddNewButton = () => {
  let params = {
    companyId: $route.params.companyId,
    moduleId: $route.params.moduleId,
    menuId: $route.params.menuId,
    pageId: $route.params.pageId,
  }
  $router.push({
    name: 'shareholder-register',
    params: params,
    query: $route.query
  })
}
const getQuery = () => {
  let query = '?company_id=' + companyId.value
  query += '&offset=' + offset.value
  query += '&is_shareholder=1'
  if (page) query += '&page=' + page.value
  if (roleId.value) query += '&role_id=' + roleId.value
  if (searchTerm) query += '&q=' + searchTerm.value
  if (start.value) query += '&start_date=' + start.value
  if (end.value) query += '&end_date=' + end.value
  if (shareholderContact.value) query += '&contact_profile_id=' + shareholderContact.value.id
  if (contactOwner.value) query += '&contact_owner_id=' + contactOwner.value.id
  return query
};

const getCompanyRoles = async () => {
  const res = await fetchCompanyDefaultRoles(`?company_id=${companyId.value}&roles=shareholder,employee`);
  if (res.status) {
    companyRoles.value = res.data
    companyRolesFetched.value = true
  }
}

const onOpenContactSearchModal = async () => {
  if (!companyRolesFetched.value) {
    await getCompanyRoles()
  }
  $store.state.isModalOpenThree = true;
}

const onOpenContactOwnerSearchModal = async () => {
  await onOpenContactSearchModal()
}

const onOpenShareholderSearchModal = async () => {
  await onOpenContactSearchModal()
}

const onSearchContact = (contact) => {
  shareholderContact.value = contact
  contactOwner.value = null
  getContactsList()
}

const onSearchByOwner = (data) => {
  contactOwner.value = data
  shareholderContact.value = null
  getContactsList()
}

async function getContactsList() {
  try {
    const res = await fetchCompanyContacts(getQuery());
    if (!res.status) {
      contacts.value = [];
      return resetPagination()
    }
    contacts.value = res.data.data;
    await setPagination(res.data)
  } catch (err) {

  }
}

const exportList = () => {
  const objQuery = {
    company_id: $route.params.companyId,
    role_id: roleId.value ?? '',
    is_shareholder: 1,
    start_date: start.value ?? '',
    end_date: end.value ?? '',
    contact_profile_id: shareholderContact.value
        ? shareholderContact.value.id
        : '',
    contact_owner_id: contactOwner.value
        ? contactOwner.value.id
        : '',
    _token: token
  }

  let params = Object.entries(objQuery).map(([key, val]) => `${key}=${val}`).join('&');
  let url = `${process.env.VUE_APP_BASE_URL}/export/contacts/?${params}`;
  let a = document.createElement('a');
  a.setAttribute('href', url);
  a.click();
}

onMounted(() => {
  loading.value = true;
  const companyQuery = `?company_id=${companyId.value}&roles=shareholder`
  const rolesRes = fetchCompanyDefaultRoles(companyQuery)
  Promise.all([
    rolesRes.then(res => {
      if (res.data) {
        companyRules.value = res.data;
        roleId.value = res.data && res.data[0].id
      }
    })
  ]).then(() => {
    loading.value = false
  }).catch((err) => {
    loading.value = false
  })
})
</script>
